module.exports = "<div *ngFor=\"let image of activeImages\" class=\"image-container\" @image>\n  <div class=\"image-info\">\n    <h2>Title</h2>\n    <p>\n      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec efficitur ipsum eget tempus vulputate.\n    </p>\n    <p>\n      Proin sed odio aliquam, commodo purus ut, auctor mauris. Mauris ut urna et tellus ullamcorper\n    </p>\n  </div>\n  <div class=\"image-preview\">\n    <app-image [image]=\"image\"></app-image>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/image-preview/image-preview.component.html
// module id = 222
// module chunks = 1